import React from "react";
import variables from "../styleVariables";

const SortDownIcon = ({ color = variables.colorBody }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className="icon-sort"
  >
    <path fill={color} d="M7 10l5 5 5-5z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

export default SortDownIcon;
